import { DataFetchingState } from '../../dataFetching/generators';
import { GenericShopApiResponse } from '../../../../common/apiAdapters/types';

export const HEADER_BAR_IDENTIFIER = 'HEADER_BAR_IDENTIFIER';

interface BannerResponce {
    id: string;
    name: string;
    startDateTime: string;
    endDateTime: string;
    desktopText: string;
    mobileText: string;
    fontColor: string;
    backgroundColor: string;
    dismissible: boolean;
    reappearenceDelay?: number;
    link?: string;
    visibility?: Array<string>;
}

export interface Banner extends BannerResponce {
    desktopHTML: string;
    mobileHTML: string;
}

export type HeaderBarBannerApiResponse = GenericShopApiResponse<BannerResponce[]>;
export interface HeaderBarBannerState extends DataFetchingState {
    banner?: Banner;
}
